<cap-sidebar [visible]="visible" styleClass="right-sidebar" position="right" [title]="title">
  <div class="right-sidebar__content">
    <ng-container *ngIf="childComponentType">
      <ng-template capDynamicDialogContent></ng-template>
    </ng-container>
  </div>
</cap-sidebar>
